<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="props.dataSource"
      :itemsCount="props.totalRecords"
      :backendPagination="true"
      :externalCurrentPage="props.currentPage"
      @onSearch="handleSearch"
      @onRequest="handlePaginationRequest"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="viewState.clearFilters"
      @onClear="handleClearSearch"
      :emptyObjectData="emptyObjectData"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
    <RemoveBadgeDialog
      v-model="viewState.state.showRemoveBadgeDialog"
      :badgeName="
        viewState.state.selectedBadge?.badge?.level ||
        viewState.state.selectedBadge?.currentBadgeLevel ||
        ''
      "
      :responsibilityName="viewState.state.selectedBadge?.name || ''"
      :employeeName="
        `${viewState.state.selectedBadge?.employee?.first_name || ''} ${
          viewState.state.selectedBadge?.employee?.last_name || ''
        }`.trim()
      "
      @remove="viewState.handleRemoveBadge"
      @close="viewState.state.showRemoveBadgeDialog = false"
    />
  </v-container>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "@/views/AsCoach/composables/useTableConfig";
import { useViewState } from "@/views/AsCoach/composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";
import RemoveBadgeDialog from "@components/RemoveBadgeDialog/RemoveBadgeDialog.vue";

const tableConfig = useTableConfig();
const viewState = useViewState();
const emptyObjectData = {
  singular: "Responsibility",
  plural: "Responsibilities",
  showClearAction: true,
};

const props = defineProps({
  dataSource: {
    type: Array,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  pageSize: {
    type: Number,
    required: true,
  },
  totalRecords: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["pageChange", "pageSizeChange", "search", "clearSearch"]);

const handleSearch = (searchText) => {
  viewState.state.filters.searchText = searchText;
  emit("search", searchText);
};

const handleClearSearch = () => {
  viewState.state.filters.searchText = "";
  emit("search", "");
};

const handlePaginationRequest = (payload) => {
  // payload contains { page, itemsPerPage }
  if (payload.page !== props.currentPage) {
    emit("pageChange", payload.page);
  }
  if (payload.itemsPerPage !== props.pageSize) {
    emit("pageSizeChange", payload.itemsPerPage);
  }
};
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
</style>
